export const emailValidationRegex =
  '^[A-Za-z0-9._%+-]+@[a-z0-9.-]+\\.[A-Za-z]{2,4}$';

export const urlValidatioRegex = /^(https?|ftp):\/\/[^\s/$.?#].[^\s]*$/i;
